import { Button, CircularProgress, Typography } from "@mui/material";
import { FC, useContext, useEffect, useState } from "react";
import CustomChipInput from "./CustomChipInput";
import { useMutation } from "react-query";
import { useParams } from "react-router-dom";
import { getClinicalImpression, postClinicalImpression } from "../../services";
import usePopup from "../../../hooks/usePopup";
// import LogComonent from "../layouts/LogComonent";
import { PatientManagementContext } from "./PatientManagementPlanProvider";
import { wordBreak } from ".";
import HistoryComponent from "../layouts/HistoryComponent";

const ClinicalImpression: FC = () => {
  const { encounterId } = useParams();
  const { showSnackbar } = usePopup();
  const { setEditedField } = useContext(PatientManagementContext);

  const [chips, setChips] = useState<string[]>([]);
  const [initialChips, setInitialChips] = useState<string[]>([]);
  const [_saved, setSaved] = useState<boolean>(false);

  // 🔹 Fetch list
  const { mutate: fetchList, data, isLoading: listLoading } = useMutation(getClinicalImpression, {
    onSuccess: (result) => {
      if (result.responseIndicator == "success") {
        const clinicalArray = result?.response?.clinicalImpression
          ? result.response.clinicalImpression.split(wordBreak)
          : [];
        setChips(clinicalArray);
        setInitialChips(clinicalArray); // ✅ store initial values
      }
    },
  });

  // 🔹 Save mutation
  const { mutate: saveClinicalImpression, isLoading: saveLoading } = useMutation(
    postClinicalImpression,
    {
      onSuccess: (result) => {
        if (result.responseIndicator == "success") {
          showSnackbar({
            message: "Saved successfully!",
            open: true,
            variant: "success",
            duration: 2000,
          });
          setEditedField(null);
          setSaved(true);
          fetchList(encounterId as string);
        } else {
          showSnackbar({
            message: "Failed!",
            open: true,
            variant: "warning",
            duration: 2000,
          });
        }
      },
      onError: () => {
        showSnackbar({
          message: "Something went wrong!",
          open: true,
          variant: "warning",
          duration: 2000,
        });
      },
    }
  );

  // 🔹 Save handler
  const handleSave = () => {
    const clinicalImpression = chips.join(wordBreak);

    // check if anything changed
    // const hasChanges =
    //   chips.length !== initialChips.length ||
    //   chips.some((chip, idx) => chip !== initialChips[idx]);
    console.log(initialChips.length)
    // if (!hasChanges) {
    //   showSnackbar({
    //     message: "No new items to add",
    //     open: true,
    //     variant: "warning",
    //     duration: 2000,
    //   });
    //   return;
    // }

    saveClinicalImpression({
      id: data?.response?.id || null,
      companyId: 0,
      encounter: parseInt(encounterId as string),
      IP: null,
      isModified: 0,
      clinicalImpression,
      status: 1,
      visitId: 0,
    });
  };

  // 🔹 Reset handler
  const handleReset = () => {
    if (chips.length > 0) {
      saveClinicalImpression({
        id: data?.response?.id || null,
        companyId: 0,
        encounter: parseInt(encounterId as string),
        IP: null,
        isModified: 1,
        clinicalImpression: "",
        status: 1,
        visitId: 0,
      });
    }
  };

  useEffect(() => {
    fetchList(encounterId as string);
  }, []);

  return (
    <div className="border-2 rounded">
      <div className="p-2 border-b flex justify-between items-center">
        <Typography color="primary" fontWeight={600}>
          Clinical Impression
        </Typography>
        <div>
          {/* <LogComonent  /> */}
          <HistoryComponent logProps={{field:"clinicalimpression",title:"Clinical Impression"}} title="clinical Impression" tableprops={tableprops} />
        </div>
      </div>
      <div className="p-2 grid grid-cols-12 gap-x-6 gap-y-2">
        <div className="col-span-9">
          <CustomChipInput
            placeholder="Clinical Impression"
            chips={chips}
            setChips={(newChips) => {
              setChips(newChips);
              setEditedField("clinicalImpression");
            }}
            loading={listLoading}
            component={"clinicalImpression"}
          />
        </div>
        <div className="col-span-2 flex gap-2 items-center">
          <Button
            color="success"
            onClick={handleSave}
            disabled={saveLoading}
            endIcon={saveLoading && <CircularProgress size={18} />}
          >
            save
          </Button>
          <Button color="error" disabled={saveLoading} onClick={handleReset}>
            reset
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ClinicalImpression;

// tableprops for history
const tableprops = [{ heading: "Clinical Impression", key: "clinicalImpression" }];
